module.exports = __webpack_public_path__ + "static/media/visit_jordan.143eb3b9.png";